export class BasicFile {
  public FileName: string;
  public FilePath: string;
  constructor(init?: Partial<BasicFile>) {
    Object.assign(this, init);
  }
}
